<template>
  <div>
    <Loader v-if="Object.keys(this.data).length === 0" />
    <div class="user-wrapper w-100" v-else>
      <profile-header></profile-header>
      <TitleContainer :title="'登録情報'"/>
      <div class="user-content">
        <div class="container profile-container">
          <div class="my-auto w-100 main-area">
            <div class="profile-detail">
              <div class="profile-info-block mb-3">
                  <div class="profile-edit-block">
                    <h2 class="rg-title">基本情報</h2>
                      <EditButton
                        title="編集"
                        @click="showModal"
                      />
                  </div>
                <div class="profile-info">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th>氏名</th>
                        <td>
                          <span class="edit-txt">{{ profile.last_name }} {{ profile.full_name }}</span>
                          <!-- <div class="custom-form-block edit-custom" v-else> -->
                        </td>
                      </tr>
                      <tr>
                        <th>ふりがな</th>
                        <td>
                          <span class="edit-txt">{{ profile.last_furigana }} {{ profile.furigana }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          性別
                        </th>
                        <td>
                          <span class="edit-txt">{{ profile.gender }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>生年月日</th>
                        <td>
                          <span class="edit-txt">{{ birthDate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>居住地</th>
                        <td>
                          <span class="edit-txt">{{
                            getResidence(profile.residence)
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>メールアドレス</th>
                        <td>
                          <span class="edit-txt">{{ profile.email }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>パスワード</th>
                        <td>
                          <span class="edit-txt">********</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- ends profile-detail-block -->


              <Academic :finalEducation="data.finalEducation" />

              <Employment :data="data" />

              <ChangeMassEmailStatus />

              <Unsubscribe />

              <!-- ends profile-info-block -->
              <b-modal
                id="modal1"
                ref="modal"
                hide-footer
                size="lg"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
                @shown="addEventListeners"
                @hide="removeEventListeners"
              >
                <template #modal-header>
                  <!-- Emulate built in modal header close button action -->
                  <!-- <button type="button" class="close" aria-label="Close" v-on:click.prevent="cancel('sharing')">
                      <span aria-hidden="true">&times;</span>
                    </button> -->
                  <h5 class="sharingTitle" style="margin-top:5px">
                    基本情報
                  </h5>
                  <CancelModal @click="cancel" />
                  <!-- <img
                    src="../assets/close.png"
                    v-on:click.prevent="cancel('personal')"
                    style="cursor:pointer;margin-top:5px"
                  /> -->
                </template>
                <form
                  v-on:submit.prevent="savePersonal"
                  data-vv-scope="personal"
                  style="max-height: 600px;overflow-y:scroll;"
                >
                  <div class="form-sep-block">
                    <div class="item-form-block">
                      <div class="form-group row">
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label">
                            <span class="span-badge mr-2">必須</span>
                            氏名
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-bind:class="{
                              'is-invalid': hasError('last_name', 'personal'),
                            }"
                            name="last_name"
                            v-model="profile.last_name"
                            v-validate="'required|max:30'"
                            data-vv-as="姓"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('last_name', 'personal')"
                          >
                             
                            {{ getErrorMessage("last_name", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label mobile-label">&nbsp;</label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError('full_name', 'personal'),
                            }"
                            name="full_name"
                            v-model="profile.full_name"
                            v-validate="'required|max:30'"
                            data-vv-as="名"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('full_name', 'personal')"
                          >
                             
                            {{ getErrorMessage("full_name", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label">
                            <span class="span-badge mr-2">必須</span>
                            ふりがな
                          </label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError(
                                'last_furigana',
                                'personal'
                              ),
                            }"
                            name="last_furigana"
                            v-model="profile.last_furigana"
                            v-validate="'required|max:30'"
                            data-vv-as="せい"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('last_furigana', 'personal')"
                          >
                             
                            {{ getErrorMessage("last_furigana", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-6 mb-30">
                          <label class="cstm-label mobile-label">
                            &nbsp;
                            <!-- <span class="text-danger">*</span> -->
                          </label>
                          <input
                            type="text"
                            class="form-control "
                            v-bind:class="{
                              'is-invalid': hasError('furigana', 'personal'),
                            }"
                            name="furigana"
                            v-model="profile.furigana"
                            v-validate="'required|max:30'"
                            data-vv-as="めい"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('furigana', 'personal')"
                          >
                             
                            {{ getErrorMessage("furigana", "personal") }}
                          </div>
                        </div>

                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            <span class="span-badge mr-2">必須</span>
                            性別
                          </label>
                          <div class="d-flex">
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios3"
                                value="指定なし"
                                checked
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios3"
                                >指定なし</label
                              >
                            </div>
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios1"
                                value="男性"
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios1"
                                >男性</label
                              >
                            </div>
                            <div class="custom-control custom-radio ml-2">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="gender"
                                v-model="profile.gender"
                                id="exampleRadios2"
                                value="女性"
                              />
                              <label
                                class="custom-control-label cstm-label"
                                for="exampleRadios2"
                                >女性</label
                              >
                            </div>
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('gender', 'personal')"
                          >
                             
                            {{ getErrorMessage("gender", "personal") }}
                          </div>
                        </div>
                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            <span class="span-badge mr-2">必須</span>
                            生年月日
                          </label>
                          <div class="d-flex justify-content-between">
                            <select
                              class="form-control mr-2  pristine-untouched"
                              v-bind:class="{
                                'is-invalid': hasError('year', 'personal'),
                              }"
                              name="year"
                              v-model="birth_date.year"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>年</option>
                              <option
                                v-for="year in years"
                                v-bind:key="year"
                                v-bind:value="year"
                              >
                                {{ year }}
                              </option>
                            </select>
                            <select
                              class="form-control mr-2 "
                              v-bind:class="{
                                'is-invalid': hasError('month', 'personal'),
                              }"
                              name="month"
                              v-model="birth_date.month"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>月</option>
                              <option
                                v-for="month in months"
                                v-bind:key="month"
                                v-bind:value="month"
                              >
                                {{ month }}
                              </option>
                            </select>
                            <select
                              class="form-control "
                              v-bind:class="{
                                'is-invalid': hasError('day', 'personal'),
                              }"
                              name="day"
                              v-model="birth_date.day"
                              v-validate="'required'"
                              data-vv-as="生年月日"
                            >
                              <option value>日</option>
                              <option
                                v-for="day in days"
                                v-bind:key="day"
                                v-bind:value="day"
                              >
                                {{ day }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="
                              hasError('day', 'personal') ||
                                hasError('month', 'personal') ||
                                hasError('year', 'personal')
                            "
                          >
                             
                            生年月日は必須項目です
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('birth_date', 'personal')"
                          >
                            <!-- <span class="icon-error invalid-date">!</span> -->
                            <span style="text-align:initial">{{
                              getErrorMessage("birth_date", "personal")
                            }}</span>
                          </div>
                        </div>
                        <div class="col-md-12 mb-30">
                          <label class="cstm-label">
                            <span class="span-badge mr-2">必須</span>
                            居住地
                          </label>
                          <select
                            class="form-control"
                            v-bind:class="{
                              'is-invalid': hasError('residence', 'personal'),
                            }"
                            name="residence"
                            v-model="profile.residence"
                            v-validate="'required'"
                            data-vv-as="居住地"
                          >
                            <option value>選択</option>
                            <option
                              v-for="residence in data.residence"
                              v-bind:key="residence._id"
                              v-bind:value="residence._id"
                            >
                              {{ residence.title }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('residence', 'personal')"
                          >
                             
                            {{ getErrorMessage("residence", "personal") }}
                          </div>
                        </div>
                        <!-- Email Section -->
                        <div class="col-md-12 mb-30" style="border-top: 1px solid #e6e6e6; padding-top: 20px; margin-top: 20px;">
                          <h5 style="margin-bottom: 20px; font-weight: 600;">メールアドレス</h5>
                          <div class="col-md-12 mb-3">
                            <label class="cstm-label" style="color: #787878">
                              現在のメールアドレス
                            </label>
                            <div class="input-group custom-group">
                              {{ profile.email }}
                            </div>
                          </div>
                          <div class="col-md-12 mb-2">
                            <label class="cstm-label">
                              <span class="span-badge mr-2">必須</span>
                              新しいメールアドレス
                            </label>
                            <div class="input-group custom-group">
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': hasError('email', 'personal') }"
                                name="email"
                                v-model="new_email"
                                v-validate="'email'"
                                data-vv-scope="personal"
                                data-vv-as="新しいメールアドレス"
                                placeholder="変更する場合のみ入力"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly')"
                              />
                              <p class="mt-2" style="color:#787878; font-weight: 600; font-size: 12px;">
                                ※携帯キャリアメール（docomo・au・softbank等）は、メールが届かない場合があります。
                                別のメールアドレスを入力いただく事を推奨します。
                              </p>
                              <div class="invalid-feedback" v-if="hasError('email', 'personal')">
                                {{ getErrorMessage("email", "personal") }}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 mb-2" v-if="new_email && new_email.trim() !== '' && new_email !== original_email">
                            <label class="cstm-label">
                              <span class="span-badge mr-2">必須</span>
                              現在のパスワード（メール変更時）
                            </label>
                            <div class="input-group custom-group">
                              <input
                                :type="inputTypeEmailPassword"
                                class="form-control password-form"
                                :class="{
                                  'is-invalid': hasError('email_password', 'personal'),
                                }"
                                name="email_password"
                                v-model="email_password"
                                v-validate="new_email && new_email !== profile.email ? 'required|doubleByte' : ''"
                                data-vv-scope="personal"
                                data-vv-as="現在のパスワード"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly')"
                              />
                              <button
                                class="btn-eye"
                                type="button"
                                v-on:click.prevent="showPassword('email')"
                              >
                                <i :class="eyeIconEmailPassword" aria-hidden="true"></i>
                              </button>
                              <div
                                class="invalid-feedback"
                                v-if="hasError('email_password', 'personal')"
                              >
                                {{ getErrorMessage("email_password", "personal") }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Password Section -->
                        <div class="col-md-12 mb-30" style="border-top: 1px solid #e6e6e6; padding-top: 20px; margin-top: 20px;">
                          <h5 style="margin-bottom: 20px; font-weight: 600;">パスワード</h5>
                          <div class="col-12 mb-2">
                            <label class="cstm-label">
                              <span class="span-badge mr-2">必須</span>
                              現在のパスワード
                            </label>
                            <div class="input-group custom-group">
                              <input
                                :type="inputTypeOldPassword"
                                class="form-control is-valid"
                                v-bind:class="{
                                  'is-invalid': hasError('old_password', 'personal'),
                                }"
                                name="old_password"
                                v-model="old_password"
                                v-validate="(new_password || password_confirmation) ? 'required|doubleByte|min:8' : ''"
                                data-vv-scope="personal"
                                data-vv-as="現在のパスワード"
                                placeholder="変更する場合のみ入力"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly')"
                              />
                              <button
                                class="btn-eye"
                                type="button"
                                v-on:click.prevent="showPassword('old')"
                              >
                                <i :class="eyeIconOldPassword" aria-hidden="true"></i>
                              </button>
                              <div
                                class="invalid-feedback"
                                v-if="hasError('old_password', 'personal')"
                              >
                                {{ getErrorMessage("old_password", "personal") }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 mb-2">
                            <label class="cstm-label full">
                              <span class="span-badge mr-2">必須</span>
                              新規パスワード
                            </label>
                            <div class="input-group custom-group">
                              <input
                                :type="inputTypeNewPassword"
                                class="form-control is-valid"
                                v-bind:class="{
                                  'is-invalid': hasError('new_password', 'personal'),
                                }"
                                name="new_password"
                                v-model="new_password"
                                v-validate="new_password ? 'required|doubleByte|min:8' : ''"
                                data-vv-scope="personal"
                                data-vv-as="パスワード"
                                ref="password"
                                placeholder="8文字以上入力してください（変更する場合のみ）"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly')"
                              />
                              <button
                                class="btn-eye"
                                type="button"
                                v-on:click.prevent="showPassword('new')"
                              >
                                <i :class="eyeIconNewPassword" aria-hidden="true"></i>
                              </button>
                              <div
                                class="invalid-feedback"
                                v-if="hasError('new_password', 'personal')"
                              >
                                {{ getErrorMessage("new_password", "personal") }}
                              </div>
                            </div>
                          </div>
                          <div class="col-12 mb-2">
                            <label class="cstm-label">
                              <span class="span-badge mr-2">必須</span>
                              新規パスワード（確認用）
                            </label>
                            <div class="input-group custom-group">
                              <input
                                :type="inputTypePasswordConfirmation"
                                class="form-control is-valid"
                                v-bind:class="{
                                  'is-invalid': hasError('password_confirmation', 'personal'),
                                }"
                                name="password_confirmation"
                                v-model="password_confirmation"
                                v-validate="new_password ? 'required|confirmed:password' : ''"
                                data-vv-scope="personal"
                                data-vv-as="新規パスワード（確認用）"
                                placeholder="8文字以上入力してください（変更する場合のみ）"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly')"
                              />
                              <button
                                class="btn-eye"
                                type="button"
                                v-on:click.prevent="showPassword('conf')"
                              >
                                <i :class="eyeIconPasswordConfirmation" aria-hidden="true"></i>
                              </button>
                              <div
                                class="invalid-feedback"
                                v-if="hasError('password_confirmation', 'personal')"
                              >
                                {{ getErrorMessage("password_confirmation", "personal") }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 text-center">
                          <button
                            data-v-bf1681ae=""
                            title="保存"
                            class="btn btn-secondary rounded font-16 profile-edit-btn"
                            @click.prevent="savePersonal"
                            :disabled="disable"
                          >
                            保存する
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <!-- ends custom-form-block -->
              </b-modal>
              <!-- OTP Verification Modal -->
              <b-modal
                id="modal2"
                ref="otpModal"
                hide-footer
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
                @shown="addEventListeners"
                @hide="removeEventListeners"
              >
                <template #modal-header>
                  <h5 class="sharingTitle" style="margin-top:5px">
                    認証コードの確認
                  </h5>
                </template>
                <form v-on:submit.prevent="handleOtpVerified">
                  <div class="form-wrap mt-4">
                    <div class="form-sep-block">
                      <div class="item-form-block">
                        <div class="form-group row">
                          <div class="col-12 mb-2" style="text-align: left;">
                            <label class="cstm-label" style="font-size:14.5px">
                              新しいメールアドレスに届いた6桁の認証コードを入力してください
                            </label>
                          </div>
                          <div class="input-group custom-group token">
                            <input
                              type="text"
                              class="form-control"
                              v-bind:class="{
                                'is-invalid': hasError('token', 'otp'),
                              }"
                              name="token"
                              v-model="token"
                              v-validate="'required'"
                              data-vv-scope="otp"
                              data-vv-as="認証コード"
                              maxlength="6"
                            />
                            <div class="invalid-feedback token-msg" v-if="hasError('token', 'otp')">
                              {{ getErrorMessage("token", "otp") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button
                          data-v-bf1681ae=""
                          title="保存"
                          class="btn btn-secondary rounded font-16 profile-edit-btn"
                          @click.prevent="handleOtpVerified"
                          :disabled="disable"
                        >
                          保存する
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
  <!-- ends profile-detail -->
</template>

<script>
/* eslint-disable */
import ProfileHeader from "@/components/header.vue";
import Api from "@/config/api";
// eslint-disable-next-line
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import swal from "sweetalert";
import logo from "../assets/Group300.png";
import Footer from "./Footer.vue";
import Unsubscribe from "./Unsubscribe.vue";
import Academic from "./Academic.vue";
import Employment from "./Employment.vue";
import Loader from "./Loader.vue";
import TitleContainer from "./TitleContainer.vue";
import ChangeMassEmailStatus from "./ChangeMassEmailStatus.vue"
import CancelModal from "./CancelModal.vue";
import EditButton from "./EditButton.vue";
import modalEventListener from "../mixins/modalEventListener";

export default {
  mixins: [modalEventListener],
  components: {
    ProfileHeader,
    Footer,
    Unsubscribe,
    Academic,
    Employment,
    Loader,
    TitleContainer,
    ChangeMassEmailStatus,
    CancelModal,
    EditButton
  },
  data() {
    return {
      data: {},
      pendingFormData: {},
      server_errors: {},
      selectedCursor: "pointer",
      tempPersonalData: {},
      isPersonelEdit: true,
      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      birth_date: {
        year: "",
        month: "",
        day: "",
      },
      maintenance_msg: "",
      show_msg: false,
      // Email fields
      new_email: "",
      email_password: "",
      token: "",
      original_email: "",
      // Password fields
      old_password: "",
      new_password: "",
      password_confirmation: "",
      // Password visibility toggles
      inputTypeEmailPassword: "password",
      eyeIconEmailPassword: "fa-solid fa-eye-slash",
      inputTypeOldPassword: "password",
      eyeIconOldPassword: "fa-solid fa-eye-slash",
      inputTypeNewPassword: "password",
      eyeIconNewPassword: "fa-solid fa-eye-slash",
      inputTypePasswordConfirmation: "password",
      eyeIconPasswordConfirmation: "fa-solid fa-eye-slash",
      disable: false,
    };
  },
  watch: {
    // eslint-disable-next-line
    // eslint-disable-next-line
    "birth_date.year": function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.month": function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.day": function() {
      this.birthDateChanged();
    },
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      selectBoxValues: "getSelectBoxValues",
    }),
    birthDate() {
      // console.log(this.profile.birth_date);
      return this.profile.birth_date;
      return moment(this.profile.birth_date).format("YYYY/MM/DD");
    },
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      selectBox: "selectBoxValues",
    }),
    ...mapMutations({
      mutateEmail: "changeEmail",
    }),
    formatDate(date, format = "YYYY-MM-DD") {
      // console.log(date);
      return moment(date)
        .utc()
        .format(format);
    },
    hasError(field, scope = null) {
      return (
        field in this.server_errors || this.errors.first(`${scope}.${field}`)
      );
    },
    getErrorMessage(field, scope = null) {
      if (field in this.server_errors) return this.server_errors[field].msg;
      else if (this.errors.first(`${scope}.${field}`)) {
        return this.errors.first(`${scope}.${field}`);
      }
      return null;
    },
    getResidence(id) {
      if (this.data.residence) {
        const result = this.data.residence.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    checkDiff(actualData, changedData) {
      for (let key of Object.keys(changedData)) {
        if (actualData[key] !== changedData[key]) {
          return true;
        }
      }
      return false;
    },
    async savePersonal(event) {
      event.preventDefault();
      this.disable = true;

      try {
        const emailChanged = this.new_email && this.new_email.trim() !== "" && this.new_email !== this.original_email;
        const passwordChanged = this.new_password && this.new_password.length > 0;
        
        const personalData = {
          full_name: this.profile.full_name,
          last_name: this.profile.last_name,
          furigana: this.profile.furigana,
          last_furigana: this.profile.last_furigana,
          gender: this.profile.gender,
          birth_date: this.profile.birth_date,
          residence: this.profile.residence,
        };
        
        const hasBasicInfoChanges = this.checkDiff(this.tempPersonalData, personalData);

        if (!emailChanged && !passwordChanged && !hasBasicInfoChanges) {
          this.cancel();
          this.disable = false;
          return;
        }

        const check = await this.$validator.validateAll("personal");
        if (!check) {
          this.disable = false;
          return;
        }

        if (emailChanged && !this.email_password) {
          this.server_errors = { email_password: { msg: "現在のパスワードを入力してください" } };
          this.disable = false;
          return;
        }

        if (passwordChanged && !this.old_password) {
          this.server_errors = { old_password: { msg: "現在のパスワードを入力してください" } };
          this.disable = false;
          return;
        }

        if (hasBasicInfoChanges) {
          const confirmResult = await this.confirmSave();
          if (!confirmResult) {
            this.disable = false;
            return;
          }
        }

        const dataForm = new FormData();
        
        Object.keys(personalData).forEach((key) =>
          dataForm.append(key, personalData[key])
        );

        if (passwordChanged) {
          dataForm.append('old_password', this.old_password);
          dataForm.append('password', this.new_password);
          dataForm.append('password_confirmation', this.password_confirmation);
        }

        if (emailChanged) {
          dataForm.append('email', this.new_email);
          dataForm.append('current_password', this.email_password);
          dataForm.append('email_change_requested', 'true');
        }

        const token = await this.$auth.getToken();
        await this.axios({
          method: "post",
          data: dataForm,
          url: Api.url(Api.endpoints.personal),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (emailChanged) {
          // Store all form data to resend with OTP verification
          this.pendingFormData = {
            personalData,
            passwordChanged,
            hasBasicInfoChanges,
            old_password: this.old_password,
            new_password: this.new_password,
            password_confirmation: this.password_confirmation,
            new_email: this.new_email
          };
          
          this.$refs.otpModal.show();
          this.disable = false;
        } else {
          await this.showSuccessMessage();
          
          if (hasBasicInfoChanges) {
            Object.assign(this.tempPersonalData, personalData);
            this.isPersonelEdit = true;
          }
          
          if (passwordChanged) {
            this.old_password = "";
            this.new_password = "";
            this.password_confirmation = "";
          }
          
          this.clearErrors();
          this.$refs.modal.hide();
          this.disable = false;
        }

      } catch (error) {
        this.handleError(error);
        this.disable = false;
      }
    },

    async handleOtpVerified() {
      try {
        this.disable = true;
        
        const { personalData, passwordChanged, new_password, password_confirmation, 
                old_password, new_email, hasBasicInfoChanges } = this.pendingFormData;
        
        // Build FormData with all fields + OTP
          const dataForm = new FormData();
        
        // Add personal data
          Object.keys(personalData).forEach((key) =>
            dataForm.append(key, personalData[key])
          );
        
        // Add password fields if password was being changed
        if (passwordChanged) {
          dataForm.append('password', new_password);
          dataForm.append('password_confirmation', password_confirmation);
          dataForm.append('old_password', old_password);
        }
        
        // Add email
        dataForm.append('email', new_email);
        
        // Add OTP
        dataForm.append('token', this.token);
        console.log(dataForm);
        // Call OTP verification endpoint
        const token = await this.$auth.getToken();
        await this.axios({
          method: "post",
          data: dataForm,
          url: Api.url(Api.endpoints.verifyNewEmail), // New endpoint
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        // Update local state
        if (hasBasicInfoChanges) {
          Object.assign(this.tempPersonalData, personalData);
          this.isPersonelEdit = true;
        }
        
        if (passwordChanged) {
          this.old_password = "";
          this.new_password = "";
          this.password_confirmation = "";
        }
        
        this.email_password = "";
        this.new_email = "";
        this.pendingFormData = null;
        
        await this.showSuccessMessage();
        
        this.clearErrors();
        this.$refs.otpModal.hide();
        this.$refs.modal.hide();
        this.disable = false;
        
      } catch (error) {
        this.handleError(error);
        this.disable = false;
      }
    },

    async showSuccessMessage() {
      let content = document.createElement("span");
      content.innerHTML = `<p style="font-weight:bold">情報を更新しました。</p>`;
      await swal({
        title: "",
        content: content,
        className: "custom-swal4",
        buttons: {
          ok: "OK",
        },
      });
    },

    handleError(error) {
      if (error.response && error.response.status === 422) {
        this.server_errors = error.response.data;
      } else if (error.response && (error.response.status === 503 || error.response.status === 401)) {
        this.$router.push({ name: "Logout" });
      } else {
        swal({
          text: error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "更新に失敗しました。少し時間を置いて再度お試しください。",
          icon: "warning",
        });
      }
    },
    async confirmSave() {
      let res = await swal({
        title: "情報を更新しますか？",
        text: `登録企業への公開情報が更新されます。\n 書類（履歴書・職務経歴書等）をアップロードまたは更新した場合、\n 登録企業すべてに同じ書類が公開されます。`,
        icon: "warning",
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: true,
          },
        },
      });
      return res;
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          const token = await this.$auth.getToken();
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          await this.axios({
            method: "post",
            data,
            url: Api.url(Api.endpoints[url]),
            headers: headers,
          });
          if (url === "personal") {
            this.tempPersonalData.full_name = this.profile.full_name;
            this.tempPersonalData.last_name = this.profile.last_name;
            this.tempPersonalData.furigana = this.profile.furigana;
            this.tempPersonalData.last_furigana = this.profile.last_furigana;
            this.tempPersonalData.birth_date = this.profile.birth_date;
            this.tempPersonalData.residence = this.profile.residence;
            // this.tempPersonalData.phone = this.profile.phone;
            this.tempPersonalData.gender = this.profile.gender;
            this.isPersonelEdit = true;
            this.$refs.modal.hide();
            // swal("", "更新しました。", "success");
          }
          let content = document.createElement("span");
          content.innerHTML = `<p style="font-weight:bold">情報を更新しました。</p>`;
          swal({
            title: "",
            content: content,
            className: "custom-swal4",
            // icon: logo,
            buttons: {
              ok: "OK",
            },
          });
          this.clearErrors();
          return true;
        } catch (error) {
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: "Logout" });
          } else {
            swal("", "Something Went Wrong", "error");
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    clearServerError(name) {
      // clear server error of resume on file change
      const { [name]: exclude, ...newServerError } = this.server_errors;
      this.server_errors = { ...newServerError };
    },
    // addEventListeners() {
    //   history.pushState({ modal: 'open' }, '');
    //   window.addEventListener('popstate', this.handlePopState);
    //   document.addEventListener('keydown', this.handleBackspace);
    // },
    // removeEventListeners() {
    //   document.removeEventListener('keydown', this.handleBackspace);
    //   window.removeEventListener('popstate', this.handlePopState);
    // },
    // handleBackspace(event) {
    //   if(event.key === 'Backspace' && 
    //       !['INPUT', 'TEXTAREA'].includes(event.target.tagName)) {
    //     event.preventDefault();
    //     this.cancel('personal');
    //   }
    // },
    // handlePopState(event) {
    //   event.preventDefault();
    //   this.cancel('personal');
    // },
    showModal() {
      this.tempPersonalData.full_name = this.profile.full_name;
      this.tempPersonalData.last_name = this.profile.last_name;
      this.tempPersonalData.furigana = this.profile.furigana;
      this.tempPersonalData.last_furigana = this.profile.last_furigana;
      this.tempPersonalData.birth_date = this.birthDate;
      this.tempPersonalData.residence = this.profile.residence;
      // this.tempPersonalData.phone = this.profile.phone;
      this.tempPersonalData.gender = this.profile.gender;
      const birthDate = new Date(this.profile.birth_date);
      this.birth_date.year = birthDate.getFullYear();
      this.birth_date.month = birthDate.getMonth() + 1;
      if (this.birth_date.month < 10 && this.birth_date.month > 0) {
        this.birth_date.month = `0${this.birth_date.month}`;
      }
      this.birth_date.day = birthDate.getDate();
      if (this.birth_date.day < 10 && this.birth_date.day > 0) {
        this.birth_date.day = `0${this.birth_date.day}`;
      }
      // Initialize email and password fields
      this.original_email = this.profile.email;
      this.new_email = "";
      this.email_password = "";
      this.token = "";
      this.old_password = "";
      this.new_password = "";
      this.password_confirmation = "";
      this.$refs.modal.show();
      
    },
    cancel() {
        if (this.$refs.otpModal && this.$refs.otpModal.isVisible) {
          this.$refs.otpModal.hide();
        } else {
          this.$refs.modal.hide();
        }
        this.profile.full_name = this.tempPersonalData.full_name;
        this.profile.last_name = this.tempPersonalData.last_name;
        this.profile.furigana = this.tempPersonalData.furigana;
        this.profile.last_furigana = this.tempPersonalData.last_furigana;
        this.profile.birth_date = this.tempPersonalData.birth_date;
        this.profile.residence = this.tempPersonalData.residence;
        this.profile.gender = this.tempPersonalData.gender;
        // Reset email and password fields
        this.new_email = "";
        this.email_password = "";
        this.token = "";
        this.old_password = "";
        this.new_password = "";
        this.password_confirmation = "";
        this.clearErrors();
    },
    async verifyOtpToken() {
      this.disable = true;
      try {
        const check = await this.$validator.validateAll("otp");
        if (!check) {
          this.disable = false;
          return;
        }

        if (!this.token) {
          this.server_errors = { token: { msg: "認証コードを入力してください" } };
          this.disable = false;
          return;
        }

        // Verify OTP
        const token = await this.$auth.getToken();
        const content1 = document.createElement("span");
        content1.innerHTML = '<p style="font-weight:bold">メールアドレスを更新しますか？</p>';
        const res = await swal({
          icon: "warning",
          content: content1,
          className: "custom-swal5",
          closeOnClickOutside: false,
          buttons: {
            cancel: "キャンセル",
            ok: "更新する",
          },
        });

        if (res) {
          await this.axios({
            method: "post",
            data: {
              token: this.token,
            },
            url: Api.url(Api.endpoints.verifyNewEmail),
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          this.mutateEmail(this.new_email);
          this.$refs.otpModal.hide();
          this.token = "";
          this.original_email = this.new_email;
          this.new_email = "";
          this.email_password = "";

          // Continue to save other changes (password and basic info)
          const personalData = {
            full_name: this.profile.full_name,
            last_name: this.profile.last_name,
            furigana: this.profile.furigana,
            last_furigana: this.profile.last_furigana,
            gender: this.profile.gender,
            birth_date: this.profile.birth_date,
            residence: this.profile.residence,
          };
          let tempDate = this.profile.birth_date;
          const changedData = {
            ...personalData,
            birth_date: tempDate,
          };
          tempDate = this.tempPersonalData.birth_date;
          const actualData = {
            ...this.tempPersonalData,
            birth_date: tempDate,
          };
          const hasBasicInfoChanges = this.checkDiff(actualData, changedData);
          const passwordChanged = this.new_password && this.new_password.length > 0;

          // Handle password change if needed
          if (passwordChanged) {
            const passwordCheck = await this.$validator.validateAll("personal");
            if (passwordCheck) {
              if (!this.old_password) {
                this.server_errors = { old_password: { msg: "現在のパスワードを入力してください" } };
                this.disable = false;
                return;
              }

              const token = await this.$auth.getToken();
              await this.axios({
                method: "post",
                data: {
                  old_password: this.old_password,
                  password: this.new_password,
                  password_confirmation: this.password_confirmation,
                },
                url: Api.url(Api.endpoints.changePassword),
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });

              this.old_password = "";
              this.new_password = "";
              this.password_confirmation = "";
            }
          }

          // Save basic info if changed
          if (hasBasicInfoChanges) {
            const check = await this.$validator.validateAll("personal");
            if (check) {
              let res = await this.confirmSave();
              console.log(res);
              if (res) {
                const dataForm = new FormData();
                Object.keys(personalData).forEach((key) =>
                  dataForm.append(key, personalData[key])
                );
                await this.save(dataForm, "personal");
              }
            }
          } else {
            // Show success message
            let content = document.createElement("span");
            content.innerHTML = `<p style="font-weight:bold">情報を更新しました。</p>`;
            await swal({
              title: "",
              content: content,
              className: "custom-swal4",
              buttons: {
                ok: "OK",
              },
            });
            this.clearErrors();
            this.$refs.modal.hide();
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.server_errors = error.response.data;
        } else if (error.response && (error.response.status === 503 || error.response.status === 401)) {
          this.$router.push({ name: "Logout" });
        } else {
          await swal({
            text: error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "認証コードの確認に失敗しました。少し時間を置いて再度お試しください。",
            icon: "warning",
          });
        }
      } finally {
        this.disable = false;
      }
    },
    showPassword(field) {
      if (field === "email") {
        if (this.inputTypeEmailPassword === "password") {
          this.inputTypeEmailPassword = "text";
          this.eyeIconEmailPassword = "fa-solid fa-eye";
        } else {
          this.inputTypeEmailPassword = "password";
          this.eyeIconEmailPassword = "fa-solid fa-eye-slash";
        }
      } else if (field === "old") {
        if (this.inputTypeOldPassword === "password") {
          this.inputTypeOldPassword = "text";
          this.eyeIconOldPassword = "fa-solid fa-eye";
        } else {
          this.inputTypeOldPassword = "password";
          this.eyeIconOldPassword = "fa-solid fa-eye-slash";
        }
      } else if (field === "new") {
        if (this.inputTypeNewPassword === "password") {
          this.inputTypeNewPassword = "text";
          this.eyeIconNewPassword = "fa-solid fa-eye";
        } else {
          this.inputTypeNewPassword = "password";
          this.eyeIconNewPassword = "fa-solid fa-eye-slash";
        }
      } else if (field === "conf") {
        if (this.inputTypePasswordConfirmation === "password") {
          this.inputTypePasswordConfirmation = "text";
          this.eyeIconPasswordConfirmation = "fa-solid fa-eye";
        } else {
          this.inputTypePasswordConfirmation = "password";
          this.eyeIconPasswordConfirmation = "fa-solid fa-eye-slash";
        }
      }
    },
    birthDateChanged() {
      this.profile.birth_date = `${this.birth_date.year}/${this.birth_date.month}/${this.birth_date.day}`;
    },
    initBirthDate() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n - 18; i += 1) {
        this.years[j] = i;
        j += 1;
      }
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;
          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = "";
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = "";
      }
    },
  },
  async mounted() {
    this.initBirthDate();
    this.checkMaintenaceMsg();
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  async created() {
    this.scrollToTop();
    // console.log(await this.$auth.isAuthenticated());
    await this.setProfile()
    // Object.keys(this.profile).length === 0 && (await this.setProfile());
    Object.keys(this.selectBoxValues).length === 0 && (await this.selectBox());

    this.data = this.selectBoxValues;
    // try {
    //   const token = await this.$auth.getToken();
    //   const response = await this.axios({
    //     method: "get",
    //     url: Api.url(`${Api.endpoints.selectBoxValues}`),
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   // let events = await this.axios({method: "get", url: Api.url(`${Api.endpoints.events}?is_test_user=${this.profile.test_user}`)});
    //   // if(events){
    //   //   this.events = events.data;
    //   //   this.isEvents = true;
    //   // }

    //   this.data = response.data.data;
    // } catch (error) {
    //   console.log(error);
    //   this.$router.push({ name: "Logout" });
    // }
  },
};
</script>
<style scoped>
@import url("../assets/css/shared.css");
#modal2 .form-sep-block {
  padding: 10px !important;
}
.form-control.is-valid{
  background-image: none;
}
.form-control.is-invalid{
  background-image: none;
}
>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}
.btn-eye {
  margin-right: 10px;
}
.item-form-block .form-control {
  min-height: 40px;
}
.password-form {
  background-image: none;
}
.input-group.custom-group.token {
  padding: 0px 23px 0px 23px !important;
}
.invalid-feedback.token-msg {
  text-align: right;
}
</style>
